import { c as _c } from "react/compiler-runtime";
import type { ButtonHTMLAttributes } from 'react';
export function Button(t0) {
  const $ = _c(8);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className: t1,
      type: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  const type = t2 === undefined ? "button" : t2;
  const t3 = `lookbook-button ${className}`;
  let t4;
  if ($[4] !== props || $[5] !== t3 || $[6] !== type) {
    t4 = <button {...props} type={type} className={t3} />;
    $[4] = props;
    $[5] = t3;
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}